module.exports = __webpack_public_path__ + "static/img/M.2 SSD-QwYZmJp2.4786b9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/M.2 SSD-QwYZmJp2.png
// module id = iIEW
// module chunks = 16